import api from "@/api/axiosApi";
import handleHttpError from "@/util/HttpErrorHandler";

const API_URL = `/section`;

const allSection = async () => {
  try {
    const response = await api.get(API_URL);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des sections :', error);
    handleHttpError(error, "Impossible de récupérer la liste des sections.");
    return [];
  }
};

export const allActiveSections = async () => {
  const url = `${API_URL}/active`;

  try {
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des sections actives :', error);
    handleHttpError(error, "Impossible de récupérer les sections actives.");
    return [];
  }
};

export const getSectionsByVisibility = async (visibilityForm) => {
  const url = `${API_URL}/is_visible/${visibilityForm}`;

  try {
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des sections par visibilité :', error);
    handleHttpError(error, "Impossible de récupérer les sections selon leur visibilité.");
    return [];
  }
};

const saveSection = async (sectionData) => {
  try {
    const response = await api.post(API_URL, sectionData);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de l\'enregistrement de la section :', error);
    handleHttpError(error, "Échec de l'enregistrement de la section.");
    throw error;
  }
};

export const getIdSection = async (sectionId) => {
  const url = `${API_URL}/${sectionId}`;
  try {
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération de la section :', error);
    handleHttpError(error, "Impossible de récupérer la section.");
    throw error;
  }
};

export const updateSection = async (sectionId, sectionData) => {
  const url = `${API_URL}/${sectionId}`;
  try {
    const response = await api.put(url, sectionData);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la mise à jour de la section :', error);
    handleHttpError(error, "Échec de la mise à jour de la section.");
    throw error;
  }
};

export const disableSection = async (sectionId, sectionData) => {
  const url = `${API_URL}/disable/${sectionId}`;
  try {
    const response = await api.put(url, sectionData);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la désactivation de la section :', error);
    handleHttpError(error, "Impossible de désactiver la section.");
    throw error;
  }
};

export const saveSectionPositions = async (sectionId, sectionData) => {
  const url = `${API_URL}/position/${sectionId}`;
  try {
    const response = await api.put(url, sectionData);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la mise à jour de la position des sections :', error);
    handleHttpError(error, "Échec de la mise à jour des positions.");
    throw error;
  }
};

export const deleteSection = async (sectionId) => {
  const url = `${API_URL}/${sectionId}`;
  try {
    await api.delete(url);
  } catch (error) {
    console.error('Erreur lors de la suppression de la section :', error);
    handleHttpError(error, "Échec de la suppression de la section.");
    throw error;
  }
};

export const updateSectionOrder = async (sectionData) => {
  const url = `${API_URL}/order`;

  try {
    const response = await api.put(url, sectionData);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la mise à jour de l\'ordre des sections :', error);
    handleHttpError(error, "Impossible de mettre à jour l'ordre des sections.");
    throw error;
  }
};

export { saveSection, allSection };
